const LOADING_NAMESPACE = "LOADING";
export const APP_LOADED: string = `${LOADING_NAMESPACE}/APP_LOADED`;
export const APP_LOADING: string = `${LOADING_NAMESPACE}/APP_LOADING`;
